import script from "./ModalHandlerMostrarListas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalHandlerMostrarListas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalHandlerMostrarListas.vue?vue&type=style&index=0&id=58ca9b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ca9b3c"]])

export default __exports__